import syncApi from './syncApi';

/*
 * Cross-entity tags client.
 *
 * A tag group is a dimension ("Trade channel") and a tag value is one of its
 * answers ("Swimart"). The group declares which entities it targets, so the
 * pickers below always ask for the vocabulary scoped to the entity they are
 * about to write — a customers-only tag never appears on a product.
 *
 * Filters elsewhere in the console take a tag *spec* rather than an id:
 * `swimart`, or `trade_channel:swimart` when a bare value code exists under
 * more than one group.
 */

const base = '/tags';

export const listTagGroups = (params) =>
  syncApi.get(`${base}/groups`, { params }).then((r) => r.data);

export const createTagGroup = (payload) =>
  syncApi.post(`${base}/groups`, payload).then((r) => r.data);

export const updateTagGroup = (id, payload) =>
  syncApi.put(`${base}/groups/${id}`, payload).then((r) => r.data);

export const deleteTagGroup = (id, cascade = false) =>
  syncApi.delete(`${base}/groups/${id}`, { params: { cascade } }).then((r) => r.data);

export const createTagValue = (groupId, payload) =>
  syncApi.post(`${base}/groups/${groupId}/values`, payload).then((r) => r.data);

export const updateTagValue = (id, payload) =>
  syncApi.put(`${base}/values/${id}`, payload).then((r) => r.data);

export const deleteTagValue = (id, cascade = false) =>
  syncApi.delete(`${base}/values/${id}`, { params: { cascade } }).then((r) => r.data);

// ── Per-entity assignment ──
export const getProductTags = (sku) =>
  syncApi.get(`${base}/products/${encodeURIComponent(sku)}`).then((r) => r.data);

export const setProductTags = (sku, tagValueIds) =>
  syncApi
    .put(`${base}/products/${encodeURIComponent(sku)}`, { tag_value_ids: tagValueIds })
    .then((r) => r.data);

export const getCustomerTags = (company, custNum) =>
  syncApi.get(`${base}/customers/${company}/${custNum}`).then((r) => r.data);

export const setCustomerTags = (company, custNum, tagValueIds) =>
  syncApi
    .put(`${base}/customers/${company}/${custNum}`, { tag_value_ids: tagValueIds })
    .then((r) => r.data);

// ── Bulk ──
// `keys` are SKUs for products and `COMPANY/CUSTNUM` for customers. The
// response carries a match report so the operator sees which pasted keys are
// not entities here before trusting the tag covers their list.
export const bulkAssignTag = (payload) =>
  syncApi.post(`${base}/assign/bulk`, payload).then((r) => r.data);

export const listCustomerTagCandidates = (q, limit = 500) =>
  syncApi.get(`${base}/customer-candidates`, { params: { q, limit } }).then((r) => r.data);
